import { gsap, Power1, TweenMax } from "gsap";

document.addEventListener('DOMContentLoaded', () => {

    const nav = document.getElementsByClassName('js-nav')[0],
          hamburger = document.querySelectorAll('.js-hamburger');

    const init = ()=> {
        const parent = nav.querySelector('.js-parent');
        
        const toggle = function(ev, section, op) {
            TweenMax.to(section, 0.4, {
                height: ev,
                opacity: op,
                immediateRender: false,
                ease: Power1.easeOut
            });
        }
        
        const open_submenu = (e)=> {
            const _that = e.currentTarget,
                  _height = 0;
                        
            if (_that.classList.contains('is-active')) {
                _that.classList.remove('is-active');
                toggle(_height, _that.parentNode.querySelector('ul'), 0);
                
            } else {
                _that.classList.add('is-active');    
                toggle('auto', _that.parentNode.querySelector('ul'), 1);
            }
            e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
        }
        
        parent ? parent.addEventListener('click', open_submenu) : false;

        window.hideMenu = ()=> {
            if (document.querySelector('.js-nav').classList.contains('is-visible')) {
                document.querySelector('.js-nav').classList.remove('is-visible');
                document.querySelector('.js-hamburger').classList.remove('is-active');                
                document.documentElement.classList.remove('is-animated');
                document.documentElement.classList.remove('mobile-menu');
                setTimeout(()=> {
                    document.querySelector('.js-nav').classList.remove('is-block');
                    document.querySelector('.js-nav').classList.remove('is-animated');
                }, 500);                
            }            
        };

        const showMenu = function() {
            nav.classList.add('is-block');
            window.addEventListener('resize', checkWindowSize);
            
            setTimeout(function() {
                document.documentElement.classList.add('mobile-menu');
            }, 10);

            setTimeout(function() {
                nav.classList.add('is-visible');
                showLinks();
            }, 100);    
            
            const showLinks = function() {
                gsap.utils.toArray(".js-menu").forEach(function(elem) {            
                    const blocks = elem.querySelectorAll(".js-item"),
                          tl = gsap.timeline().delay(.2).eventCallback("onComplete", function() {
                              document.documentElement.classList.add('is-animated');
                          })

                    .from(blocks, {
                        y: -60,
                        duration: .8,
                        opacity: 0,
                        stagger: {
                            each: 0.1
                        },
                        ease: 'elastic.out(1, .8)',
                    });
                });
            };        
        };

        const toggleMenu = function(e) {
            nav.classList.contains('is-visible') ? hideMenu() : showMenu();
        };
        

        // Click event

        for (let i = 0; i < hamburger.length; i++) {
            hamburger[i].addEventListener('click', toggleMenu);
        }

        // Hide menu on ESC

        document.addEventListener('keydown', function(evt) {
            // evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key == "Escape" || evt.key == "Esc");
            } else {
                isEscape = (evt.keyCode == 27);
            }
            if (isEscape) {
                hideMenu();
            }
        });
        
        
        const checkWindowSize = function() {
            
            if (window.innerWidth > 1300) {
                hideMenu();
                window.removeEventListener('resize', checkWindowSize);
            }
        };
        
        document.querySelector('.js-closeNav').addEventListener('click', hideMenu);
        
        window.addEventListener('resize', checkWindowSize);

    };

    nav ? init() : false;

}, false);